import { Component } from 'react';

import { connectFavorites } from './FavoritesConnectors';
import withDefaultPrevented from '../../../../withDefaultPrevented';
import { OCNameFilter } from '../../../Utilities';
import PriceRange from '../PriceRange';
import { FeatureImage } from '../feature_utils';
import { altText } from '../imageAlts';

const FEATURES_TO_SHOW = ['scoty', 'coolcolor'];

const FavoriteItem = ({ favorite, onRemove, removed, t, locale, address }) => (
  <div className={`favorite-tile ${removed ? 'removed' : ''}`}>
    <div className="favorite-feature">
      <FeatureImage address={address} item={favorite} className="favorites" featuresSubset={FEATURES_TO_SHOW} />
      <a href={`/roofing/shingles/${favorite.shingle.uid}?color=${favorite.uid}`}>
        <img
          src={favorite.house_cropped_768x768_url2}
          alt={altText(
            favorite,
            'house_thumb',
            locale.code,
            `${favorite.name} ${favorite.shingle.name} ${t('shingles.two_story_home')}`
          )}
        />
      </a>
      <a
        href="#"
        className="favorite-heart"
        onClick={withDefaultPrevented(() => onRemove(favorite.uuid))}
        aria-label={`${t('shingles.remove_favorite')} ${favorite.name}`}
      >
        <i className="fa fa-heart" aria-hidden="true" />
      </a>
    </div>
    <div className="favorite-details">
      <OCNameFilter element="div" className="favorite-proper-name">
        {favorite.shingle.proper_name}
      </OCNameFilter>
      <div className="favorite-name">{favorite.name}</div>
      <div className="favorite-price">
        <PriceRange uid={favorite.shingle.price_uid} />
      </div>
    </div>
  </div>
);

class FavoriteItemContainer extends Component {
  constructor(props) {
    super(props);
    this.state = { removed: false };
  }

  onRemove(uuid) {
    this.setState({ removed: true });
    setTimeout(() => this.props.removeFromFavorites(uuid), 250);
  }

  render() {
    return (
      <FavoriteItem
        {...this.props}
        address={this.props.address}
        onRemove={uuid => this.onRemove(uuid)}
        removed={this.state.removed}
      />
    );
  }
}

export default connectFavorites(FavoriteItemContainer);
